import React from "react";
import { OverlayTrigger, Tooltip, Popover } from "react-bootstrap";
import { FaQuestionCircle, FaInfoCircle } from "react-icons/fa";

// Componente para tooltips simples
export const HelpTooltip = ({ text, placement = "top", variant = "info" }) => (
  <OverlayTrigger
    placement={placement}
    overlay={<Tooltip>{text}</Tooltip>}
  >
    <span className={`text-${variant} ms-1`} style={{ cursor: "help" }}>
      <FaQuestionCircle size={14} />
    </span>
  </OverlayTrigger>
);

// Componente para popovers con más información
export const HelpPopover = ({ 
  title, 
  content, 
  placement = "top", 
  variant = "info",
  size = 16 
}) => {
  const popover = (
    <Popover>
      <Popover.Header as="h6" className="fw-bold">{title}</Popover.Header>
      <Popover.Body>{content}</Popover.Body>
    </Popover>
  );

  return (
    <OverlayTrigger
      trigger="click"
      placement={placement}
      overlay={popover}
      rootClose
    >
      <span className={`text-${variant} ms-1`} style={{ cursor: "help" }}>
        <FaInfoCircle size={size} />
      </span>
    </OverlayTrigger>
  );
};

// Componente para secciones de ayuda expandibles
export const HelpSection = ({ title, children, defaultExpanded = false }) => {
  const [expanded, setExpanded] = React.useState(defaultExpanded);

  return (
    <div className="help-section border rounded p-3 mb-3 bg-light">
      <div 
        className="d-flex align-items-center justify-content-between"
        style={{ cursor: "pointer" }}
        onClick={() => setExpanded(!expanded)}
      >
        <h6 className="mb-0 text-primary fw-bold">
          <FaInfoCircle className="me-2" />
          {title}
        </h6>
        <small className="text-muted">
          {expanded ? "Ocultar" : "Ver ayuda"}
        </small>
      </div>
      {expanded && (
        <div className="mt-3 text-muted">
          {children}
        </div>
      )}
    </div>
  );
};